import {Strings} from '@zvne/fe-framework/dist/presentation/language/strings';

const en = {
    title: 'Nowcasting',
    loginTitle: 'Login',
    live: 'Live',
    history: 'History'
};

const hr = {
    title: 'Nowcasting',
    loginTitle: 'Prijava',
    live: 'Uživo',
    history: 'Povijest'
};

export const strings: Strings<typeof en> = {en, hr};
